import {AppFunction} from "../misc/types";
import {DeliveryView} from "../views/delivery";
import {PickupView} from "../views/pickup";
import {ConfigView} from "../views/config";

export class ConfigFunction extends AppFunction {

    readonly v : ConfigView;

    constructor() {
        super();
        this.v = new ConfigView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/config`;
    }

}
